import React from "react";
import { useI18n } from "../i18n/I18nContext";

const SECTIONS = {
  en: [
    { h: "What we collect", b: "We collect your email and name when you create an account, and your order details when you purchase a guide. Nothing else." },
    { h: "Why we collect it", b: "To deliver the products you buy, send service emails, and improve the platform. We never sell or rent your data." },
    { h: "Payments", b: "Payments are processed by Stripe. We never see or store your card details." },
    { h: "Email", b: "Transactional and account emails are sent from hello@thelifeplot.com via Resend. You can unsubscribe from non-essential mail at any time." },
    { h: "Your rights", b: "Write to hello@thelifeplot.com any time to access, export, or delete your data. We reply within five business days." },
  ],
  ro: [
    { h: "Ce colectăm", b: "Colectăm emailul și numele tău la crearea contului, plus detaliile comenzii când cumperi un ghid. Nimic mai mult." },
    { h: "De ce colectăm aceste date", b: "Pentru a livra produsele cumpărate, pentru a trimite emailuri de serviciu și pentru a îmbunătăți platforma. Nu vindem și nu închiriem datele tale." },
    { h: "Plăți", b: "Plățile sunt procesate de Stripe. Nu vedem și nu stocăm detaliile cardului tău." },
    { h: "Email", b: "Emailurile tranzacționale și de cont sunt trimise de la hello@thelifeplot.com prin Resend. Te poți dezabona de la mesaje non-esențiale oricând." },
    { h: "Drepturile tale", b: "Scrie-ne la hello@thelifeplot.com pentru a accesa, exporta sau șterge datele tale. Răspundem în cinci zile lucrătoare." },
  ],
};

export default function Privacy() {
  const { t, lang } = useI18n();
  const items = SECTIONS[lang];
  return (
    <article className="container py-16 md:py-24 max-w-3xl">
      <p className="font-mono-label text-gold/80 mb-4">
        {t.legal.updated} · {new Date().toLocaleDateString(lang === "ro" ? "ro-RO" : "en-US", { year: "numeric", month: "long" })}
      </p>
      <h1 className="font-display text-section md:text-section-lg tracking-tight leading-[1.05]">
        {t.legal.privacyTitle}
      </h1>
      <p className="mt-6 ed-italic text-subtitle text-cream-muted">{t.legal.privacyIntro}</p>
      <div className="divider-fade my-12" />
      <div className="space-y-12">
        {items.map((s, i) => (
          <section key={i}>
            <h2 className="font-display text-card-lg tracking-tight">{s.h}</h2>
            <p className="mt-4 text-cream-muted text-body leading-relaxed">{s.b}</p>
          </section>
        ))}
        <section>
          <p className="text-small text-cream-muted">
            {lang === "en" ? "Questions? " : "Întrebări? "}
            <a href="mailto:hello@thelifeplot.com" className="text-gold hover:text-gold-hover">hello@thelifeplot.com</a>
          </p>
        </section>
      </div>
    </article>
  );
}
